import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { TopicCreateInput } from '@/Domain/api/Conversation/ConversationTopics.api';
import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';

export const useConversationTopicCreate = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation<TopicDto, Error, TopicCreateInput>({
    mutationKey: [QueryKey.conversationTopics.create],
    onSuccess: (data) => {
      queryClient.setQueryData(
        [QueryKey.conversationTopics.list],
        (prev: TopicDto[] | undefined) => [...(prev ?? []), data],
      );
    },
  });

  const handleCreateTopic = (topic: TopicCreateInput) => mutation.mutateAsync(topic);

  return { handleCreateTopic, isPending: mutation.isPending };
};
